import React from 'react';
import { Box } from '@components/Box';
import { TextPairing } from '@components/TextPairing';
import { useCultureSectionController } from './CultureSection.controllers';
import { careersPageData } from '@data-ts/pages/careers';
import { DesktopContainer, StyledColumns, StyledColumn, StyledBox, AssetWrapper, StyledCloudImage } from './CultureSection.styles';

export const CultureSectionDesktop: React.FC = () => {
  const cultureData = careersPageData.culture;
  const { containerRef, impactAssetRef, buildAssetRef, funAseetRef } = useCultureSectionController();
  const items = [
    {
      title: 'Make an impact.',
      body:
        'At Joy, you will not just be a cog in the machine. You will directly see the results of your work, as a key member of a quickly-growing team.',
      image: 'careers/culture/1-impact.jpg',
      assetRef: impactAssetRef,
    },
    {
      title: 'Build something special.',
      body:
        'We strive to bring joy to our users as they plan one of the most special days of their lives. Decisions you make truly matter to our customers.',
      image: 'careers/culture/2-build.jpg',
      assetRef: buildAssetRef,
    },
    {
      title: 'Have Fun.',
      body:
        'We work hard, and we enjoy what we do.  We want you to pursue passions, take risks, and have fun, doing your life’s best work.',
      image: 'careers/culture/3-fun.jpg',
      assetRef: funAseetRef,
    },
  ];
  return (
    <DesktopContainer ref={containerRef} paddingTop={12} paddingBottom={13}>
      <TextPairing
        eyebrow={cultureData.eyebrow}
        eyebrowVariant="sectionEyeBrow24"
        eyebrowColor={'humana5'}
        eyebrowTagName="h3"
        title={cultureData.title}
        titleVariant="hed72Hero"
        titleColor={'neutra6'}
        titleTagName="h2"
        textAlign="center"
        alignment={'center'}
      />
      <Box marginTop={10}>
        <StyledColumns multiline stackOnMobile={false}>
          <StyledColumn width={5}>
            {items.map((item, index) => (
              <StyledBox key={index}>
                <TextPairing
                  title={item.title}
                  titleVariant="calloutHed32"
                  titleColor="neutra6"
                  titleTagName="h3"
                  body={item.body}
                  bodyVariant="dek20"
                  bodyColor="neutra5"
                  textAlign={'left'}
                />
              </StyledBox>
            ))}
          </StyledColumn>
          <StyledColumn width={7}>
            {items.map((itemAsset, index) => (
              <AssetWrapper ref={itemAsset.assetRef} key={index}>
                <StyledCloudImage src={itemAsset.image} width="100%" />
              </AssetWrapper>
            ))}
          </StyledColumn>
        </StyledColumns>
      </Box>
    </DesktopContainer>
  );
};
